// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MTSVC","col":"styles_col__2FFAP"};